export default __webpack_public_path__ + "static/media/02-1v2.bc839d01.png";